import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { Pill } from "../pill/pill.es.js";
import { Tooltip } from "../tooltip/tooltip.es.js";
const propTypes = {
  autoFocus: PropTypes.oneOf(["click", "cancel"]),
  children: PropTypes.node.isRequired,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  isFreeText: PropTypes.bool,
  onClick: PropTypes.func,
  onRemove: PropTypes.func.isRequired,
  tooltip: PropTypes.string
};
const defaultProps = {
  autoFocus: void 0,
  error: false,
  isFreeText: false,
  onClick: void 0,
  tooltip: void 0
};
const Token = ({
  autoFocus,
  children,
  error,
  isFreeText,
  onClick,
  onRemove,
  tooltip
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
    onClick();
  };
  return /* @__PURE__ */ jsx(Tooltip, { title: tooltip, placement: "top", children: /* @__PURE__ */ jsx(
    Pill,
    {
      "aria-selected": "true",
      appearance: error ? "error" : "default",
      autoFocus,
      cancellable: true,
      clickable: isFreeText,
      magnitude: "small",
      onClick: handleClick,
      onCancel: onRemove,
      role: "option",
      children
    }
  ) });
};
Token.propTypes = propTypes;
Token.defaultProps = defaultProps;
export {
  Token
};
